import { HttpErrorResponse } from '@angular/common/http';
import { SnackBarService } from '../../core/services/snackbar.service';
import { Observable, throwError } from 'rxjs';

export class ServerErrorUtils {
  static getValidationMessages(response: HttpErrorResponse): string[] {
    if (
      response &&
      response.error &&
      response.error.error &&
      ['2009', '2005', '2003', '2001', '400', 400].includes(response.error.error.code)
    ) {
      return response.error.error.messages;
    }
    return null;
  }

  static serverValidationOrMsg(e: HttpErrorResponse, sbs: SnackBarService, defaultMsg: string) {
    const messages = ServerErrorUtils.getValidationMessages(e);
    if (messages) {
      messages.forEach((m) => sbs.error(m));
    } else {
      sbs.error(defaultMsg);
    }
  }

  static handleError(error: any, errorMsg: string, snackBarService: SnackBarService): Observable<never> {
    const messages = ServerErrorUtils.getValidationMessages(error);
    if (messages && messages.length > 0) {
      messages.forEach((m) => snackBarService.error(m));
    } else {
      snackBarService.error(errorMsg);
    }
    return throwError(error);
  }
}
